export const BASE_URL = "https://sparkademy.directus.app";

export const CDN_ASSETS_URL = "https://cms-assets.sparkademy.com";

export const generateImageUrl = (imageId: string) => {
  // cloudfront is returning errors for some images
  // return `${CDN_ASSETS_URL}/${imageId}?access_token=6t8QsiptwYY9BiDhUYdq`;
  return `${BASE_URL}/assets/${imageId}?access_token=6t8QsiptwYY9BiDhUYdq`;
};
